export default __webpack_public_path__ + "static/media/MinecraftBedrock.33d7f726.jpeg";